import React, { useState } from 'react';

import StockMobileSidePanel from '@/components/StockMobileSidePanel';
import { OptionType } from '@/typings/common';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  getStockFilterParams,
  setCarBattery,
  setPage,
} from '@/store/reducers/cars-stock';
import {
  convertFilterParamsToOptionsByKey,
  handleChangeMultiSelect,
} from '@/modules/CarsStock/components/common.helpers';
import StockFilterMultiSelect from '@/components/StockFilterMultiSelect';

import {
  FilterButton,
  FilterButtonWrapper,
  MobileFilterItemWrapper,
} from '../../../../../../../common.styles';

function BatteryTypeFilter() {
  const dispatch = useTypedDispatch();
  const stockFilterParams = useTypedSelector(getStockFilterParams);
  const selectedBattery =
    useTypedSelector(getSelectedFilters).selectedParams.selectedBattery;
  const [isOpened, setOpened] = useState(false);

  const batteryOptions = convertFilterParamsToOptionsByKey(
    stockFilterParams,
    'batteryTypes'
  );

  const handleSidePanelOpen = () => {
    setOpened(true);
  };

  const handleSidePanelClose = () => {
    setOpened(false);
  };

  const handleChangeBattery = (battery: OptionType) => {
    dispatch(setCarBattery(handleChangeMultiSelect(battery, selectedBattery)));
    dispatch(setPage(1));
  };

  const handleClearBattery = () => {
    dispatch(setCarBattery([]));
    dispatch(setPage(1));
  };

  return (
    <StockMobileSidePanel
      title="Батарея для электро"
      zIndex={10001}
      isInnerSidePanel
      isOpened={isOpened}
      onOpen={handleSidePanelOpen}
      onClose={handleSidePanelClose}
    >
      <MobileFilterItemWrapper>
        <StockFilterMultiSelect
          options={batteryOptions}
          selectedOptions={selectedBattery}
          onChange={handleChangeBattery}
          onClear={handleClearBattery}
        />
      </MobileFilterItemWrapper>

      <FilterButtonWrapper>
        <FilterButton onClick={handleSidePanelClose}>Применить</FilterButton>
      </FilterButtonWrapper>
    </StockMobileSidePanel>
  );
}

export default BatteryTypeFilter;
